module.exports = __webpack_public_path__ + "img/stats_3.4ea0ea55.png";